import React from "react";
import classes from "./LeadershipVoicesBanner.module.css";
import SecondaryButton from "../../../../components/Buttons/SecondaryButton";

function LeadershipVoicesBanner() {
  const cardData = [
    {
      title: "Professional Recording Studio",
      desc: "Step into a world-class setup, no tech worries.",
    },
    {
      title: "Expert Interview Format",
      desc: "We guide the conversation, so your wisdom shines.",
    },
    {
      title: "Zero Cost, Maximum Reach",
      desc: "No hidden fees, just pure impact.",
    },
    {
      title: "Share Your Journey",
      desc: "Leadership struggles, victories, and more.",
    },
  ];

  const scrollToPodcastSection = () => {
    const element = document.getElementById("book-a-podcast");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.leftSection}>
          <h2 className={classes.heading}>
            <span>YOUR PLATFORM FOR</span> 
            <span className={classes.highlight}>THOUGHT LEADERSHIP</span>
          </h2>
          <div className={classes.divider}></div>
          <p className={classes.description}>
            Bookalooza, the leading self-publishing platform for children, is
            now giving school principals a chance to be heard through our{" "}
            <span className={classes.highlight}>
              Voice of Leadership Podcast.
            </span>
          </p>
          <SecondaryButton onClick={scrollToPodcastSection} className={classes.bookPodcastBtn}>Book Podcast</SecondaryButton>
        </div>

        <div className={classes.rightSection}>
          {cardData.map((card, index) => (
            <div key={index} className={classes.card}>
              <h2 className={classes.cardTitle}>{card.title}</h2>
              <p className={classes.cardDescription}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LeadershipVoicesBanner;
